import { EStripeSubStatus } from '../../../models/consts';
import { IChatgptUser, ITrialDataAPI } from '../../../models/models';
import { EChatgptPlanNames, chatgptPlans } from '../../../models/paymentPlans/chatgpt-payments-plan';
import { trialDaysFinishDate } from '../../../utils/trialDaysLeft';
import {
  chatgptConvAdapterFunc,
  chatgptUserAdapterFunction,
  gitlabRepoAdapterFunc,
  gitlabUserAdapterFunction
} from '../../functions';
import {EGithubPlanNames} from "../../../models/paymentPlans/github-payments-plan";

export const fetchChatgptUsersAction = (state, { payload }) => {
  if (payload) {
    state.chatgpt.usersLoading = false;
    state.chatgpt.users = chatgptUserAdapterFunction(payload.profiles);
  }
};

export const addChatgptUserAction = (state, { payload }) => {
  if (payload) {
    state.chatgpt.users = gitlabUserAdapterFunction([payload] as Array<IChatgptUser>);
  }
};

export const fetchItemsForChatgptUserAction = (state, { payload }) => {
  if (payload) {
    state.chatgpt.itemsLoading = false;
    state.chatgpt.items = chatgptConvAdapterFunc(payload.conversations || []);
    state.chatgpt.canUserBackup = payload.canUserBackup
    state.chatgpt.totalItems = payload.totalCount || 0
    state.chatgpt.limits = payload.limits || []
  }
};

export const addChatgptItemsAction = (state, { payload }) => {
  state.chatgpt.items?.push(...gitlabRepoAdapterFunc(payload));
}

export const deleteChatgptItemAction = (state, { meta }) => {
  if (state?.chatgpt.items && meta.arg) {
    state.chatgpt.items = [...state.chatgpt.items]?.filter(x => x.id !== meta.arg);
  }
}

export const checkChatgptTrialStatusAction = (state, { payload }) => {
  if (payload) {
    state.chatgpt.isConnectionActive = !!payload.isConnectionActive

    const trialData = payload as ITrialDataAPI;
    state.chatgpt.trial = {
      trialStatus: trialData.trialStatus,
      finishDate: trialDaysFinishDate(trialData.trialHoursLeft),
      trialHoursLeft: trialData.trialHoursLeft,
      availableItemsQuantity: trialData.availableItemsQuantity,
      addedItemsQuantity: trialData.addedItemsQuantity,
      planQuantity: trialData.trialDefaultQuantity,
      isInvoiceRequested: trialData.stripe_chatgpt_subscription_bank_transfer_requested || false,
      isCancel: false
    };

    const { s3_region, cloud_storages, stripe_chatgpt_next_invoice, subscription_type, subscription_period, stripe_chatgpt_subscription_cancel_at_period_end, stripe_chatgpt_conversations_quantity, stripe_chatgpt_subscription_status, availableItemsQuantity, addedItemsQuantity, stripe_chatgpt_subscription_bank_transfer_requested, stripe_chatgpt_subscription_current_period_end } = trialData;

    state.chatgpt.storage = cloud_storages || []
    if (s3_region) {
      state.chatgpt.regionS3 = s3_region
    }

    if (stripe_chatgpt_subscription_status && stripe_chatgpt_conversations_quantity) {
      const planData = chatgptPlans.find(({ name }) => name === EChatgptPlanNames.ESSENTIAL);
      const isAnnual = subscription_period && subscription_period === 'year' || planData?.stripeIds.yearly === trialData.stripe_chatgpt_price_id;

      const cost = stripe_chatgpt_next_invoice ? stripe_chatgpt_next_invoice / 100 : 0;

      state.chatgpt.subscription = {
        status: stripe_chatgpt_subscription_status.toLowerCase() as EStripeSubStatus,
        planName: subscription_type === 'pro_plan' ? EGithubPlanNames.PRO : EGithubPlanNames.ESSENTIAL,
        isAnnual,
        finishDate: stripe_chatgpt_subscription_current_period_end ? new Date(Number(stripe_chatgpt_subscription_current_period_end + '000')).toLocaleDateString() : null,
        finishDateInMillisecond: Number(stripe_chatgpt_subscription_current_period_end +'000' ),
        cost,
        quantity: availableItemsQuantity,
        addedItemsQuantity: addedItemsQuantity,
        planQuantity: stripe_chatgpt_conversations_quantity,
        isInvoiceRequested: stripe_chatgpt_subscription_bank_transfer_requested || false,
        isCancel: stripe_chatgpt_subscription_cancel_at_period_end || false
      };
    } else if (stripe_chatgpt_subscription_status) {
      state.chatgpt.subscription = {
        status: stripe_chatgpt_subscription_status.toLowerCase() as EStripeSubStatus,
        // planName: EChatgptPlanNames.ESSENTIAL,
        // isAnnual:
        // finishDate: stripe_chatgpt_subscription_current_period_end ? new Date(Number(stripe_chatgpt_subscription_current_period_end + '000')).toLocaleDateString() : null,
        cost: 0,
        addedItemsQuantity: addedItemsQuantity,
        // quantity: availableItemsQuantity,
        // planQuantity: stripe_chatgpt_projects_quantity,
        // isInvoiceRequested: stripe_chatgpt_subscription_bank_transfer_requested || false,
        // isCancel: stripe_chatgpt_subscription_cancel_at_period_end || false
      };
    }
  }
}


